// prefer default export if available
const preferDefault = m => (m && m.default) || m

exports.components = {
  "component---src-pages-404-js": () => import("./../../../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-conto-autoral-js": () => import("./../../../src/pages/conto-autoral.js" /* webpackChunkName: "component---src-pages-conto-autoral-js" */),
  "component---src-pages-detalhes-js": () => import("./../../../src/pages/detalhes.js" /* webpackChunkName: "component---src-pages-detalhes-js" */),
  "component---src-pages-index-js": () => import("./../../../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-templates-project-page-layout-js": () => import("./../../../src/templates/project-page-layout.js" /* webpackChunkName: "component---src-templates-project-page-layout-js" */)
}

